'use client'

import { useEffect, useState } from 'react'

import {
  getBlogChecklistItem,
  setBlogChecklistItem,
} from '@/lib/blog-checklist-storage'

type BlogChecklistCheckboxProps = {
  checklistId: string
  className?: string
  initialChecked?: boolean
  itemId: string
  label: string
}

export default function BlogChecklistCheckbox({
  checklistId,
  className,
  initialChecked = false,
  itemId,
  label,
}: BlogChecklistCheckboxProps) {
  const [checked, setChecked] = useState(initialChecked)

  useEffect(() => {
    setChecked(getBlogChecklistItem(checklistId, itemId))
  }, [checklistId, itemId])

  const handleChange = (nextChecked: boolean) => {
    setChecked(nextChecked)
    setBlogChecklistItem(checklistId, itemId, nextChecked)
  }

  return (
    <input
      aria-label={label}
      checked={checked}
      className={className}
      onChange={(event) => handleChange(event.target.checked)}
      type="checkbox"
    />
  )
}
